export function isRetina() {
  return window.devicePixelRatio >= 2;
}
